<script setup>
import {ref, computed, onMounted, onBeforeUnmount, watchEffect} from 'vue'
import PageHead from "@/components/PageHead/PageHead.vue";
import Width from "@/pages/Index/Width.vue";
import axios from "axios";
import ListBlock from "@/components/ListBlock/ListBlock.vue";
import {useWindowResize} from "@/utils";
import {useStore} from "vuex";
import {pageBg} from "@/constant";
import { useRoute } from "vue-router";

const store = useStore()
const route = useRoute()

const { handleWindowResizeWithDebounce, windowSize } = useWindowResize()

const activeTab = ref(0)
const productList = ref([])
const total = ref(0)
const page = ref(1)
const gridOptions = ref({
	columns: 3,
	rowGap: 30,
	columnGap: 30
})
const category = ref([])

const currentLang = computed(() => {
	
	const lang = store.getters.currentLanguage
	
	return lang === 'cn' ? 'zh' : lang
	
})

const imageList = computed(() => productList.value?.map(item => item?.product_image))

const tabList = computed(() =>{
	return category.value.map(item => {
		const l = store.getters.currentLanguage
		return {
			label: item?.[`text_${l}`],
			value: item?.id
		}
	})
})

const handleTabChange = (e) => {
	page.value = 1
	getProductList()
}

const getProductList = () => {
	axios.get("/api/api/products?page=" + page.value + `&paginate=6&category_id=${activeTab.value}`)
		.then((res) => {
			console.log(res.data);
			productList.value = res.data.data
			total.value = res.data.total
	});
}

const getProductCategory = async () => {
	const res = await axios.get('api/api/category')
		.catch(err => {
			throw new Error(err.message)
		})
	category.value = res.data
	activeTab.value = route.query.tab ? parseInt(route.query.tab) : res.data[0].id
}

const handlePageChange = (e) => {
	page.value = e.page
	getProductList()
	window.scrollTo({
		top: 0,
		left: 0,
		behavior: 'smooth'
	})
}

watchEffect(() => {
	if (windowSize.value <= 1024) {
		gridOptions.value.columns = 2
		gridOptions.value.columnGap = 20
		gridOptions.value.rowGap = 20
	} else {
		gridOptions.value.columns = 3
		gridOptions.value.columnGap = 30
		gridOptions.value.rowGap = 30
	}
})

onMounted(async () => {
	window.addEventListener('resize', handleWindowResizeWithDebounce)
	await getProductCategory()
	getProductList()
})

</script>

<template>
	<div class="product">
		<PageHead
			:title="$t('content.Productdisplay')"
			:bg-image="pageBg.productBg"
		/>
		
		<Width>
			<div class="product__content">
				<el-tabs
					v-model="activeTab"
					class="product__content__tab"
					@tab-change="handleTabChange"
				>
					<el-tab-pane
						v-for="(tab, index) in tabList"
						:name="tab.value"
						:label="tab.label"
					/>
				</el-tabs>
				
				<ListBlock
					:total="total"
					:columns="gridOptions.columns"
					:column-gap="gridOptions.columnGap"
					:row-gap="gridOptions.rowGap"
					@pageChange="handlePageChange"
					v-if="productList.length"
				>
					<div
						class="list__item"
						v-for="(item, index) in productList"
						:key="index"
					>
						<div class="list__item__cover">
							<el-image
								:src="item.product_image"
								:preview-src-list="imageList"
								:initial-index="index"
								style="width: 100%; height: 100%;"
								fit="cover"
							/>
						</div>
						
						<div class="list__item__title">
							{{ item?.[`product_name_${currentLang}`] }}
						</div>
					</div>
				</ListBlock>
				
				<div v-else>
					<el-empty description="暂无数据..." />
				</div>
			</div>
		</Width>
	</div>
</template>

<style scoped lang="less">
.product {
	background-color: #f5f5f5;
	padding-bottom: 70px;
	&__content {
		margin-top: 30px;
		
		&__tab {
			margin-bottom: 72px;
		}
		
		.list__item {
			
			&__cover {
				background-color: #fff;
				height: 285px;
			}
			
			&__title {
				font-weight: bold;
				padding: 16px 20px;
				background-color: #fff;
				color: #3D3D3D;
			}
		}
		
	}
	
	::v-deep(.el-tabs__item) {
		color: #3D3D3D;
		font-size: 20px;
		
		.is-active {
			font-weight: bold;
		}
		
	}
	
	::v-deep(.el-tabs__nav) {
		
		.is-active {
			color: @primary-color;
			font-weight: bold;
		}
		
		.el-tabs__active-bar {
			background-color: @primary-color;
		}
	}
}

@media only screen and (max-width: 1024px) {
	.product {
		background-color: #f5f5f5;
		padding-bottom: 30px;
		&__content {
			margin-top: 30px;
			
			&__tab {
				margin-bottom: 20px;
			}
			
			.list__item {
				
				&__cover {
					//height: 177px;
				}
				
				&__title {
				
				}
			}
			
		}
		
		::v-deep(.el-tabs__item) {
			font-size: 16px;
		}
	}
}

@media only screen and (max-width: 768px) {
	.product {
		
		&__content {

			.list__item {
				
				&__cover {
					height: 132px;
				}
				
				&__title {
					font-size: 14px;
				}
			}
			
		}
	}
}
</style>